export function getRightFirstTimePercent(totalChecked, totalEverRejected) {
  if (!totalChecked) return null;
  const passedFirstTime = totalChecked - totalEverRejected;
  const ratio = Math.max(0, passedFirstTime) / totalChecked;
  return ratio * 100;
}

export function formatPercent(value) {
  return value == null ? '—' : `${value.toFixed(1)}%`;
}

export const PRODUCT_TYPE_LABELS = {
  FRAME: 'Frame (N & C combined)',
  ANCILL: 'Ancillary Boxes',
  HARDWARE: 'Hardware Boxes',
  WELDED: 'Welded Cills'
};

const FIXED_PRODUCT_TYPES = ['FRAME', 'ANCILL', 'HARDWARE', 'WELDED'];

export function normalizeProductType(rawType) {
  const key = (rawType || '').toUpperCase();
  if (key === 'FRAME') return 'FRAME';
  if (key.startsWith('ANCIL')) return 'ANCILL';
  if (key.startsWith('HARDWARE')) return 'HARDWARE';
  if (key.startsWith('WELD') || key.includes('CILL')) return 'WELDED';
  return null;
}

export function isRejectedStatus(status) {
  return !!status && status.toLowerCase() !== 'ok';
}

export function summarizeCheckedItemsByProductType(items) {
  const byType = {};
  (items || []).forEach(item => {
    const type = normalizeProductType(item.productType);
    if (!type) return;
    if (!byType[type]) byType[type] = { overallItems: [], toCheckItems: [], checkedItems: [], rejectedItems: [] };
    byType[type].overallItems.push(item);
    if (item.isChecked) {
      byType[type].checkedItems.push(item);
      if (isRejectedStatus(item.status)) byType[type].rejectedItems.push(item);
    } else {
      byType[type].toCheckItems.push(item);
    }
  });

  return FIXED_PRODUCT_TYPES.map(type => {
    const g = byType[type] || { overallItems: [], toCheckItems: [], checkedItems: [], rejectedItems: [] };
    return {
      key: type,
      label: PRODUCT_TYPE_LABELS[type],
      totalScheduled: g.overallItems.length,
      totalToCheck: g.toCheckItems.length,
      totalChecked: g.checkedItems.length,
      totalRejected: g.rejectedItems.length,
      overallItems: g.overallItems,
      toCheckItems: g.toCheckItems,
      checkedItems: g.checkedItems,
      rejectedItems: g.rejectedItems
    };
  });
}

export function summarizeRemakeItemsByProductType(items) {
  const list = items || [];
  const byType = {};
  list.forEach(item => {
    const type = normalizeProductType(item.typeName);
    if (!type) return;
    if (!byType[type]) byType[type] = { totalRemakeItems: [], toCheckItems: [], checkedItems: [], rejectedItems: [] };
    byType[type].totalRemakeItems.push(item);
    if (item.status) {
      byType[type].checkedItems.push(item);
      if (isRejectedStatus(item.status)) byType[type].rejectedItems.push(item);
    } else {
      byType[type].toCheckItems.push(item);
    }
  });

  return {
    totalRemake: list.length,
    groups: FIXED_PRODUCT_TYPES.map(type => {
      const g = byType[type] || { totalRemakeItems: [], toCheckItems: [], checkedItems: [], rejectedItems: [] };
      return {
        key: type,
        label: PRODUCT_TYPE_LABELS[type],
        totalRemake: g.totalRemakeItems.length,
        totalToCheck: g.toCheckItems.length,
        totalChecked: g.checkedItems.length,
        totalRejected: g.rejectedItems.length,
        totalRemakeItems: g.totalRemakeItems,
        toCheckItems: g.toCheckItems,
        checkedItems: g.checkedItems,
        rejectedItems: g.rejectedItems
      };
    })
  };
}
